"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DTOFactory = void 0;
const gal_base_1 = require("./gal-base");
const gal_events_1 = require("./gal-events");
const gal_reporting_groups_1 = require("./gal-reporting-groups");
const DTOFactory = function (eventType, allowedGroups = [gal_reporting_groups_1.GalReportingGroups.product]) {
    const dtoValue = class DTO extends gal_base_1.GalBaseDTO {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "type", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: gal_events_1.GalEvents[eventType]
            });
        }
        static allowedGroups() {
            return Object.freeze(allowedGroups);
        }
    };
    return dtoValue;
};
exports.DTOFactory = DTOFactory;
